export default __webpack_public_path__ + "static/media/55.31700cb9.png";